const NoRatings = ({ t, openRatingModal }) => {
  return (
    <div className='mx-auto flex max-w-sm flex-col items-center justify-center rounded-2xl p-6 text-center'>
      <p className='mb-3 text-gray-600'>{t('no_ratings')}</p>
      <button
        onClick={openRatingModal}
        className='text-primary border-primary rounded-lg border bg-white px-6 py-2 font-medium transition-colors hover:bg-[#283a6e] hover:text-white'
      >
        {t('first_review')}
      </button>
    </div>
  );
};

export default NoRatings;
